<template>
    <div class="section-wrapper">
        <div class="wrapper compact-padding container">
            <div class="container-grid">
                <div class="text">
                    <h1 class="heading--lg heading">MOVING TO<br/>
                        ANOTHER COUNTRY
                    </h1>
                    <p class="paragraph text-left">Talent knows no boundaries, which is why our company welcomes
                        professionals from all over the world. But of course, we know that moving to another country
                        can feel
                        like a big step. To make your transition as convenient as possible, we’re happy to introduce
                        you to our
                        beautiful country, and help you with all the necessary paperwork, accommodation, and
                        everything else
                        your new expat situation might ask for.</p>

                        <div class="button-wrapper">
                            <basic-button tag="a" to="https://careers.bohemia.net/expats" type="black-bordered"
                                        class="learn-button">
                                Learn More
                            </basic-button>
                        </div>
                    <div class="divider"></div>
                </div>
                <div class="image">
                    <img src="/static/img/landing_page/mobile/lifeincz_bis_mobile.png"
                         srcset="/static/img/lifeincz_bis.jpg 1000w" class="responsive--img">
                    <div class="gradient-box"></div>
                </div>

            </div>
            <div class="isocahedron-wrapper">
                <img src="/static/img/landing_page/pyramid/Pyramid.svg" class="isocahedron">
                <img src="/static/img/landing_page/pyramid/Rectangle%2010.svg" class="rectangle">
                <img src="/static/img/landing_page/pyramid/Polygon%202.svg" class="triangle">
                <div class="gradient-line line-transform"></div>
            </div>
        </div>

    </div>
</template>

<script>


  import BasicButton from "../BasicButton";

  export default {
    components: { BasicButton },
    name: "living-czech"

  };
</script>

<style scoped lang="scss" type="text/scss">
    @import "../../assets/scss/main";

    .isocahedron-wrapper {
        position: absolute;
        left: -225px;
        bottom: 290px;
        @media (max-width: 1650px) {
            display: none;
        }

        .polygon {
            position: absolute;
            top: -36px;
            right: 165px;
        }

        .rectangle {
            position: absolute;
            top: 54px;
            right: -48px;
            transform: rotateZ(-14deg);
        }

        .triangle {
            position: absolute;
            bottom: -36px;
            left: 30px;
            transform: rotateZ(-14deg);
        }

        .isocahedron {
        }

        .gradient-line {
            position: absolute;
            top: 0;
            left: -10px;
            width: 166px;
            height: 4px;
            transform: rotateZ(203deg);
            background-image: -webkit-gradient(linear, right top, left top, from(rgba(251, 176, 59, 0.85)), to(rgba(244, 77, 82, 0.85)));
            background-image: linear-gradient(270deg, rgba(251, 176, 59, 0.85) 0%, rgba(244, 77, 82, 0.85) 100%);
            background-repeat: no-repeat;
            background-size: 100% 15px;
        }

        @-moz-keyframes spin {
            100% {
                -moz-transform: rotate(360deg);
            }
        }
        @-webkit-keyframes spin {
            100% {
                -webkit-transform: rotate(360deg);
            }
        }
        @keyframes spin {
            100% {
                -webkit-transform: rotate(360deg);
                transform: rotate(360deg);
            }
        }
    }

    .container-grid {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap-reverse;
        justify-content: center;
    }

    .section-wrapper {
        position: relative;
        width: 100%;
        overflow: hidden;
        padding-top: 75px;
        @media (max-width: $tablet) {
            padding-top: 25px;
        }
    }

    .wrapper {
        margin-bottom: 250px;
        @media (max-width: $tablet) {
            margin-bottom: 120px;
        }
        @media (max-width: $compact) {
            margin-bottom: 30px;
        }
    }

    .heading {
        color: $text-strong;
        z-index: 4;
        position: relative;
        margin-bottom: $heading-margin-bottom;

        @media (max-width: $tablet) {
            margin-left: 0;
            margin-bottom: 15px;
            margin-top: 20px;
        }
    }

    .text {
        position: relative;
        z-index: 2;
        padding: 0;
        @media (min-width: $compact) {
            flex: 1;
            padding-right: 15px;
            padding-top: 0px;
        }
        @media (min-width: $tablet) {
            flex: 1;
            padding-right: 34px;
            padding-top: 94px;
        }
    }

    .responsive--img {
        width: 100%;
    }

    .image {
        position: relative;
        width: 690px;
        max-width: 690px;

        @media (max-width: $compact) {
            width: 100%;
        }

        @media (max-width: $compact) {
            width: 190px;
        }

        @media (max-width: $tablet) {
            width: 400px;
            max-width: 400px;
        }
        @media (max-width: 1200px) {
            width: 500px;
            max-width: 500px;
        }

    }

    .grid-item {
        position: relative;
    }

    
    .learn-button {
        margin-top: 89px;

        @media (max-width: $tablet) {
            margin-left: 0;
            margin-top: 10px;
        }
        @media (max-width: 1200px) {
            margin-top: 10px;

        }
    }


    .gradient-box {
        background-image: linear-gradient(to top, rgba(251, 176, 59, 0.85) 0%, rgba(244, 77, 82, 0.85) 100%);
        position: absolute;
        z-index: -2;
        opacity: .9;
        width: 329px;
        height: 650px;
        bottom: 0;
        right: -58px;
        top: -58px;
        @media (max-width: 1200px) {
            width: 185px;
            height: 515px;
            right: -55px;
            top: -28px;
        }
        @media (max-width: $tablet) {
            width: 185px;
            height: 515px;
            right: -55px;
            top: -28px;
        }
        @media (max-width: $compact) {
            width: 40%;
            height: 90%;
            right: -20px;
            top: -25px;
            z-index: -1;
        }
    }

    .button-learn {
        margin-top: 4em;
    }

    .container {
        position: relative;
    }

    .button-wrapper {
        @media (max-width: $compact) {
            margin-top: 20px;
            display: flex;
            justify-content: center;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/landingPageComponents/livingCzech.vue